import Breadcrumb from '../components/extensions/Breadcrumb'
import HomeMiddle from '../components/extensions/HomeMiddle'

const blockExtensions = {
	breadcrumb: Breadcrumb,
	HomeMiddle
}

export {blockExtensions}



// WEBPACK FOOTER //
// ./src/conf/extensions.js